import { PERCENTAGE, NULL } from 'ui/card/constants';
import { getNumberType, metricSentenceCase } from 'modules/productAnalytics/utils';
import { ToggletipForFilteredProxiedOpensMetrics } from 'modules/messagingInsights/constants';
import { AnalyticsCard } from 'ui/card';
import {
  selectIsWebInAppReportingFeatureFlagOn,
  selectIsMetricDefinitionsFeatureFlagOn,
  selectIsContextualizedMetricsFeatureFlagOn,
} from 'core/userContext/selectors';
import { useSelector } from 'react-redux';
import { kebabCase } from 'lodash';
import { InAppToBreakdown, WEB_INAPP_BREAKDOWN_UNSUPPORTED_METRICS } from '../constants';
import { selectDestinationsByBreakdownMetrics } from '../selectors';
import { StyledAnalyticsCardContainer } from './Styled';
import { InAppTooltipBreakdown } from './InAppTooltipBreakdown';
import { MetricDefinitionWrapper } from './MetricDefinitionWrapper';

const processTooltip = (key, results, inAppFF, messageMedium, destinations) => {
  if (
    inAppFF &&
    messageMedium === 'InApp' &&
    InAppToBreakdown[key] &&
    results[InAppToBreakdown[key]]
  ) {
    let total = 0;
    (destinations[key] || []).forEach((destination) => {
      total += destination?.value ? parseInt(destination?.value, 10) : 0;
    });
    if (Object.keys(destinations).length === 0 || !destinations[key]) {
      return null;
    }
    return (
      <div data-test={`in-app-${kebabCase(key)}-destination-breakdown`}>
        {(destinations[key] || []).map((destination, idx) => (
          <div
            key={`${key}-${destination.appName}`}
            data-test={`in-app-${kebabCase(key)}-destination-breakdown-row-${idx}`}
          >
            <InAppTooltipBreakdown
              destination={destination}
              total={total}
              numberType={key.toLowerCase().includes('rate') ? 'percentage' : 'number'}
            />
          </div>
        ))}
      </div>
    );
  }
  return null;
};

export const PinnedMetricCards = ({ selectedKeys, results, messageMedium }) => {
  const isWebInAppReportingOn = useSelector(selectIsWebInAppReportingFeatureFlagOn);
  const destinations = useSelector(selectDestinationsByBreakdownMetrics);
  const metricDefFFOn = useSelector(selectIsMetricDefinitionsFeatureFlagOn);
  const isContextualizedMetricsOn = useSelector(selectIsContextualizedMetricsFeatureFlagOn);

  return (
    <>
      {selectedKeys.map((key, idx) => {
        if (key === null) {
          return <div key={`null-${idx}`} />;
        }
        const val = results[key]?.value;

        // adds informational toggletip for Filtered Proxied Opens metrics if the key is one of the FPO metrics
        let tooltip = ToggletipForFilteredProxiedOpensMetrics[key];

        if (messageMedium === 'InApp' && isWebInAppReportingOn) {
          tooltip = WEB_INAPP_BREAKDOWN_UNSUPPORTED_METRICS.find(
            (metric) => metric.mediumMetricDisplayName === key,
          )?.tooltipContent;
        }

        const DefinitionWrapper = ({ children }) => (
          <MetricDefinitionWrapper metricName={key}>{children}</MetricDefinitionWrapper>
        );

        if (typeof val === 'number') {
          const numType = getNumberType(key);
          return (
            <AnalyticsCard
              key={key}
              title={metricSentenceCase(key)}
              TitleWrapper={DefinitionWrapper}
              helpText={tooltip}
              value={numType === PERCENTAGE ? val * 100 : val}
              valueType={numType}
              valueTooltipContent={processTooltip(
                key,
                results,
                isWebInAppReportingOn,
                messageMedium,
                destinations,
              )}
              AnalyticsCardContainerComponent={StyledAnalyticsCardContainer}
              metricDefFFOn={!isContextualizedMetricsOn && metricDefFFOn}
            />
          );
        }
        return (
          <AnalyticsCard
            key={key}
            title={metricSentenceCase(key)}
            TitleWrapper={DefinitionWrapper}
            helpText={tooltip}
            valueType={NULL}
            valueTooltipContent={processTooltip(
              key,
              results,
              isWebInAppReportingOn,
              messageMedium,
              destinations,
            )}
            AnalyticsCardContainerComponent={StyledAnalyticsCardContainer}
            metricDefFFOn={!isContextualizedMetricsOn && metricDefFFOn}
          />
        );
      })}
    </>
  );
};
